import {
  Controller,
  useFormContext,
  useFormState,
  useWatch,
} from "react-hook-form";

import {
  ELEMENT_WRAPPER_MB,
  ElementWrapper,
  ErrorMessage,
  Label,
  Select,
  createValidation,
  getErrorMessage,
} from "@up/form";

import type { TErrorMessageKey } from "@up/form";
import type { ChangeEvent } from "react";

export const StudentAgeName = "student-age";

export function StudentAge() {
  const { control, register } = useFormContext();
  const { errors } = useFormState();
  const formValues = useWatch();

  const KEY = StudentAgeName;
  const VALIDATION = { presence: true };
  const ERRORS = errors[KEY];
  const OPTIONS = [
    {
      value: "13",
      key: "13",
    },
    {
      value: "14",
      key: "14",
    },
    {
      value: "15",
      key: "15",
    },
    {
      value: "16",
      key: "16",
    },
    {
      value: "17",
      key: "17",
    },
    {
      value: "18",
      key: "18+",
    },
  ];

  const transform = {
    input: (value: string | number) => {
      return typeof value !== "number" || value === 0 ? "" : value.toString();
    },
    output: (e: ChangeEvent<HTMLSelectElement>) => {
      const output = parseInt(e.target.value, 10);
      return isNaN(output) ? 0 : output;
    },
  };

  return (
    <ElementWrapper className={ELEMENT_WRAPPER_MB} hasErrors={!!ERRORS}>
      <Label htmlFor={KEY} required text="Student Age" />
      <Controller
        defaultValue=""
        control={control}
        name="student-age"
        render={({ field }) => (
          <Select
            data={OPTIONS}
            displayKey="key"
            hasErrors={!!ERRORS}
            placeholderText="Please select"
            name="student-age"
            registerProps={register(
              KEY,
              createValidation(VALIDATION, formValues),
            )}
            value={transform.input(field.value)}
            onChange={(e: ChangeEvent<HTMLSelectElement>) =>
              field.onChange(transform.output(e))
            }
            valueKey="value"
            style={{ minWidth: "9rem", maxWidth: "10rem" }}
          />
        )}
      />
      <ErrorMessage
        text={
          ERRORS
            ? getErrorMessage(ERRORS.type as TErrorMessageKey, VALIDATION)
            : null
        }
      />
    </ElementWrapper>
  );
}
